import type { User } from '../../../types/interfaces';
import type { DiagnosticKind, DiagnosticTypeInfo } from '../../../types/diagnosticsInterfaces';

// Те же группы, что уже используются в pages/Devices/Devices.tsx для определения
// персонала — держим синхронно, чтобы раздел и его карточки гейтились одинаково.
const INTERNAL_GROUPS = [
  'MANAGER',
  'OFFICE_MANAGER',
  'SALES_DIRECTOR',
  'HD_HEAD',
  'HD_ENGINEER',
  'HD_SERVICE_ENGINEER',
  'admins',
];
const CLIENT_GROUPS = ['COMPANY_OWNER', 'USER', 'BASIC'];
const REMOTE_CREATE_GROUPS = ['HD_ENGINEER', 'HD_HEAD'];

export function isDiagnosticsStaff(me: User | null | undefined): boolean {
  if (!me) return false;
  const groups: string[] = me.groups ?? [];
  const hasInternal = groups.some((g) => INTERNAL_GROUPS.includes(g));
  const hasClient = groups.some((g) => CLIENT_GROUPS.includes(g));
  return hasInternal || (!hasClient && Boolean(me.is_staff || me.is_superuser));
}

/** Дистанционную диагностику создаёт только тех. поддержка / руководитель / superuser. */
export function canCreateRemote(me: User | null | undefined): boolean {
  if (!me) return false;
  if (me.is_superuser) return true;
  return (me.groups ?? []).some((g) => REMOTE_CREATE_GROUPS.includes(g));
}

export function typeByKind(
  types: DiagnosticTypeInfo[],
  kind: DiagnosticKind,
): DiagnosticTypeInfo | undefined {
  return types.find((t) => t.kind === kind);
}

export function kindOfTicketType(
  types: DiagnosticTypeInfo[],
  ticketTypeId: number | null | undefined,
): DiagnosticKind | null {
  if (!ticketTypeId) return null;
  return types.find((t) => t.ticket_type.id === ticketTypeId)?.kind ?? null;
}

/** «б/н», если серийника нет. */
export const serialOrNone = (serial: string | null | undefined): string =>
  serial && serial.trim() ? serial : 'б/н';

export const formatDate = (iso: string | null | undefined): string => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('ru-RU');
};
